import { Typography } from '@mui/material'
import { append, remove, update } from 'ramda'
import React from 'react'

import { CampaignAddButton } from '@/app/module/campaigns/component/helpers'
import { LocalOnAnswerType } from '@/app/module/campaigns/types'

import ResponseCatiMultiSelectItem from './response-cati-multiselect-item'

type Props = {
  id: string
  onAnswer: LocalOnAnswerType[]

  onChange: (value: { onAnswer?: LocalOnAnswerType[] }) => void
}

const ResponseCatiMultiSelect: React.FC<Props> = ({ id, onAnswer, onChange }) => {
  const handleChange = React.useCallback(
    (value: LocalOnAnswerType, choiceIndex: number) => {
      const currentChoice = onAnswer[choiceIndex]
      onChange({
        onAnswer: update(
          choiceIndex,
          {
            ...currentChoice,
            // Multi-select has no actions
            actions: [],
            label: typeof value.label === 'string' ? value.label : currentChoice.label || '',
            reply: typeof value.reply === 'string' ? value.reply : currentChoice.reply || '',
          },
          onAnswer,
        ),
      })
    },
    [onAnswer, onChange],
  )

  const handleRemove = React.useCallback(
    (choiceIndex: number) => onChange({ onAnswer: remove(choiceIndex, 1, onAnswer) }),
    [onAnswer, onChange],
  )

  return (
    <div className="campaign-specific-tab-content">
      <Typography>Options</Typography>
      <div>
        <Typography color="textSecondary" variant="caption" gutterBottom={true}>
          Specify the selectable options for this question.
        </Typography>
        {onAnswer.map(({ reply, label = '' }, i: number) => (
          <ResponseCatiMultiSelectItem
            key={`cati-multi-${i}`}
            choiceIndex={i}
            id={id}
            isCloseDisabled={onAnswer.length === 1}
            label={label}
            reply={reply || ''}
            onChange={handleChange}
            onRemove={handleRemove}
          />
        ))}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CampaignAddButton
            tooltip="Add option"
            onClick={() => {
              onChange({
                onAnswer: append(
                  {
                    replies: [],
                    reply: '',
                    ranges: [],
                    actions: [],
                    label: '',
                  },
                  onAnswer,
                ),
              })
            }}
            text="Add option"
            icon="add"
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(ResponseCatiMultiSelect)
